import { createFileRoute } from "@tanstack/react-router";
import { UsersIcon } from "lucide-react";
import { UsersTable } from "@/components/admin/users-table";
import { requireAdminSection } from "@/lib/admin-guard";

export const Route = createFileRoute("/_admin/users/")({
  beforeLoad: ({ context }) => requireAdminSection(context.auth.capabilities, "users"),
  component: AdminUsersPage,
});

function AdminUsersPage() {
  return (
    <div className="flex flex-1 flex-col gap-8 p-6">
      <header className="flex flex-col gap-2">
        <div className="flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-muted-foreground">
          <UsersIcon className="size-3.5" />
          Operate
        </div>
        <div className="flex flex-col gap-1">
          <h1 className="font-heading text-3xl font-semibold tracking-tight">Users</h1>
          <p className="max-w-2xl text-sm text-muted-foreground">
            Everyone with an HR Docket account — their role, verification status, and how many
            workspaces they belong to.
          </p>
        </div>
      </header>

      <UsersTable />
    </div>
  );
}
